import React from 'react';
import { FileTextIcon, LockIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
import { policies } from '../data/policies';
export function Policies() {
  return <section id="politicas" aria-labelledby="politicas-title" className="relative bg-plum-deep py-20 sm:py-24" data-id="element-149" data-mp="1zchlo5shcxej">
      <TornEdge colorClassName="bg-plum-deep" data-id="element-150" data-mp="298b3o4oyxj3p" />
      <div className="relative mx-auto w-full max-w-4xl px-5 sm:px-8" data-id="element-151" data-mp="296ztnn4xjf45">
        <Reveal data-id="element-152" data-mp="248y8mwny15q1">
          <SectionHeading id="politicas-title" folio="Sección VIII · Aviso legal" title="Políticas del Sitio" align="left" data-id="element-153" data-mp="24983oynui32l" />
        </Reveal>

        <ul className="mt-12 space-y-4" data-id="element-154" data-mp="2db7idkbe0v2d">
          {policies.map((policy, index) => <Reveal as="li" key={policy} delay={index * 0.05} data-id="element-155" data-mp="nvzzqzmied65" data-mpi={index}>
              <div className="flex gap-4 border border-dashed border-gold/45 bg-ink/50 p-5 text-sm leading-relaxed text-body sm:p-6 sm:text-[0.95rem]" data-id="element-156" data-mp="iwwrz7f59suh">
                <span className="font-folio text-[0.6rem] uppercase tracking-[0.18em] text-gold/80" data-id="element-157" data-mp="3nw98bcim029o">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span data-id="element-158" data-mp="1mg8w7dmujqg">{policy}</span>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:gap-4" data-id="element-159" data-mp="6fho6ghr4lak">
          <a href="#terminos" className="folder-tab inline-flex w-full items-center justify-center gap-2.5 border border-gold/60 px-6 py-3.5 font-display text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-gold hover:bg-gold/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold sm:w-auto" data-id="element-160" data-mp="ahw68ydljh0s">
            <FileTextIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-161" data-mp="2m649a57xdnal" />
            Términos y Condiciones
          </a>
          <a href="#privacidad" className="folder-tab inline-flex w-full items-center justify-center gap-2.5 border border-gold/60 px-6 py-3.5 font-display text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-gold hover:bg-gold/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold sm:w-auto" data-id="element-162" data-mp="2r4p8c1bfy0xg">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-163" data-mp="2o2u5ep9fypjk" />
            Política de Privacidad
          </a>
        </Reveal>
      </div>
    </section>;
}